<template>
    <breeze-authenticated-layout>
        <template #header>
            <h2 class="font-semibold text-3xl text-gray-800 leading-tight py-2">
                Heads
            </h2>
        </template>

        <breeze-page :submenus="subMenus">
            <slot></slot>
        </breeze-page>
    </breeze-authenticated-layout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'
import BreezePage from '@/Components/Page'

export default {
    components: {
        BreezeAuthenticatedLayout,
        BreezePage
    },
    data() {
        return {
            subMenus: [
                {
                    'title': 'Contacts',
                    'active': route().current('heads.contact.*'),
                    'route': 'heads.contact.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Contact' || permission.name === 'Edit Contact' || permission.name === 'View Contact')
                },
                {
                    'title': 'Applications',
                    'active': route().current('heads.application.*'),
                    'route': 'heads.application.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Application Letter' || permission.name === 'Edit Application Letter' || permission.name === 'View Application Letter')
                },
                {
                    'title': 'Payment Mode',
                    'active': route().current('heads.paymentmode.*'),
                    'route': 'heads.paymentmode.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Payment Mode' || permission.name === 'Edit Payment Mode' || permission.name === 'View Payment Mode')
                },
                {
                    'title': 'Expense Type',
                    'active': route().current('heads.expensetype.*'),
                    'route': 'heads.expensetype.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Expense Type' || permission.name === 'Edit Expense Type' || permission.name === 'View Expense Type')
                },
                {
                    'title': 'Salary Head',
                    'active': route().current('heads.salaryhead.*'),
                    'route': 'heads.salaryhead.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Salary Head' || permission.name === 'Edit Salary Head' || permission.name === 'View Salary Head')
                },
                {
                    'title': 'Roles',
                    'active': route().current('heads.role.*'),
                    'route': 'heads.role.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Role' || permission.name === 'Edit Role' || permission.name === 'View Role')
                },
                {
                    'title': 'Department',
                    'active': route().current('heads.department.*'),
                    'route': 'heads.department.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission =>
                        permission.name === 'Create Department' ||
                        permission.name === 'Edit Department' ||
                        permission.name === 'View Department'
                    )
                },
                {
                    'title': 'Designation',
                    'active': route().current('heads.designation.*'),
                    'route': 'heads.designation.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission =>
                        permission.name === 'Create Designation' ||
                        permission.name === 'Edit Designation' ||
                        permission.name === 'View Designation'
                    )
                },
                {
                    'title': 'Holiday',
                    'active': route().current('heads.holiday.*'),
                    'route': 'heads.holiday.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission =>
                        permission.name === 'Create Holiday' ||
                        permission.name === 'Edit Holiday' ||
                        permission.name === 'View Holiday'
                    )
                },
            ]
        }
    },
}
</script>
